import TickersPanel from './TickersPanel/index';
import { LS_TICKERS_HEIGHT } from './TickersPanel';

import './styles.scss';

const getSavedHeight = () => {
  const value = localStorage.getItem(LS_TICKERS_HEIGHT);
  if (value) {
    return Math.max(300, Number(value));
  } else {
    return 432;
  }
};

const TickersModal = () => {
  const isMobile = window.innerWidth < 768;
  const height = isMobile ? window.innerHeight : getSavedHeight();

  return (
    <div className='tickers__modal' style={{ height }}>
      <TickersPanel />
    </div>
  );
};

export default TickersModal;
